import { render, staticRenderFns } from "./qianbao04_list.vue?vue&type=template&id=4f80b054&scoped=true"
import script from "./qianbao04_list.vue?vue&type=script&lang=js"
export * from "./qianbao04_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f80b054",
  null
  
)

export default component.exports